import NotificationElement from './elements/NotificationElement'
import WishlistButtonElement from './elements/WishlistButtonElement'
import WishlistItemElement from './elements/WishlistItemElement'
import WishlistProductSlideoutElement from './elements/WishlistProductSlideoutElement'
import WishlistSlideoutElement from './elements/WishlistSlideoutElement'
import WishlistCreateListElement from './elements/WishlistCreateListElement'
import { initWishlistProvider } from './helpers/provider-bootstrap'
import { openModal } from './helpers/useModal'

// import './styles/base.css'

declare global {
  interface Window {
    wishlistOpenModal?: typeof openModal
  }
}

function onInit() {
  if (GM_STATE.wishlist.enable) {
    initWishlistProvider().catch((error) => {
      console.warn('Wishlist provider failed to initialize', error)
    })
  }
  window.wishlistOpenModal = openModal
  window.customElements.define('wishlist-button', WishlistButtonElement)
  window.customElements.define('wishlist-slideout', WishlistSlideoutElement)
  window.customElements.define('wishlist-create-list', WishlistCreateListElement)
  window.customElements.define('wishlist-item', WishlistItemElement)
  window.customElements.define('wishlist-product-slideout', WishlistProductSlideoutElement)
  window.customElements.define('custom-notification', NotificationElement)
}

onInit()
